import { Component, Input } from '@angular/core';
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import { NgClass, NgIf } from '@angular/common';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { FormatDateArrayPipe } from '../../common/pipes/format-date-array/format-date-array.pipe';
import { SsoUserDetailsDto } from '../../common/interfaces/sso-user-details-dto';

@Component({
    selector: 'mmoa-email-verification',
    standalone: true,
    imports: [
        FormatDateArrayPipe,
        NgIf,
        FaIconComponent,
        NgClass
    ],
    templateUrl: './email-verification.component.html',
    styleUrl: './email-verification.component.scss'
})
export class EmailVerificationComponent {
    @Input() userDetails?: SsoUserDetailsDto | null;
    @Input() inlineVerificationDate = false;
    protected readonly faCircleCheck = faCircleCheck;
}
